import { Button } from '@protoss/ui';
import { formatDate } from '../../../lib/datetime';
import { useCalendarConnection } from '../hooks/useCalendarConnection';
import './calendar-settings-pane.css';

export function CalendarSettingsPane() {
  const { status, loading, connecting, error, connect } = useCalendarConnection();

  if (loading) {
    return (
      <div className="ss-settings-pane">
        <p className="ss-settings-pane__loading">Loading…</p>
      </div>
    );
  }

  const isConnected = status?.connected === true;

  const connectedAtLabel = status?.connectedAt != null ? formatDate(status.connectedAt) : null;

  return (
    <div className="ss-settings-pane">
      <div className="ss-settings-section">
        <p className="ss-settings-section__title">Google Calendar</p>

        <div className="ss-settings-view">
          <p
            className={`cal-settings__status ${
              isConnected ? 'cal-settings__status--connected' : 'cal-settings__status--disconnected'
            }`}
          >
            {isConnected ? 'Connected' : 'Not connected'}
          </p>

          {isConnected && connectedAtLabel && (
            <p className="cal-settings__meta">Since {connectedAtLabel}</p>
          )}

          {error != null && <p className="ss-settings-pane__error">{error}</p>}

          <Button
            type="button"
            variant={isConnected ? 'ghost' : 'primary'}
            size="sm"
            onClick={connect}
            disabled={connecting}
          >
            {connecting
              ? isConnected
                ? 'Reconnecting…'
                : 'Connecting…'
              : isConnected
                ? 'Reconnect'
                : 'Connect Google Calendar'}
          </Button>
        </div>

        <p className="ss-settings-pane__hint ss-settings-pane__hint--em">
          This connects your personal calendar, not the whole workspace.
        </p>
      </div>
    </div>
  );
}
